module.exports = __webpack_public_path__ + "img/mobile-tabs.6bf62ba5.png";